import { render } from "./InicioPage.vue?vue&type=template&id=1efda984&scoped=true"
import script from "./InicioPage.vue?vue&type=script&lang=js"
export * from "./InicioPage.vue?vue&type=script&lang=js"

import "./InicioPage.vue?vue&type=style&index=0&id=1efda984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efda984"]])

export default __exports__